<div class="layout-row-wrap responsive-column">
  <h2 class="mat-h2 flex-100">{{ fixedDepositProduct.name }}</h2>

  <mat-divider class="flex-100"></mat-divider>
  <h3 class="mat-h3 flex-100">{{ 'labels.inputs.Details' | translate }}</h3>

  <mat-divider class="flex-100"></mat-divider>
  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Short Name' | translate }}:</span>
    <span class="flex-60">{{ fixedDepositProduct.shortName }}</span>
  </div>

  @if (fixedDepositProduct.description) {
    <div class="layout-row flex-100">
      <span class="flex-40">{{ 'labels.inputs.Description' | translate }}:</span>
      <span class="flex-60">{{ fixedDepositProduct.description }}</span>
    </div>
  }

  <h3 class="mat-h3 flex-100">{{ 'labels.inputs.Currency' | translate }}</h3>

  <mat-divider class="flex-100"></mat-divider>
  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Currency' | translate }}:</span>
    <span class="flex-60">{{
      fixedDepositProduct.currencyCode | find: fixedDepositProductsTemplate.currencyOptions : 'code' : 'name'
    }}</span>
  </div>

  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Decimal Places' | translate }}:</span>
    <span class="flex-60">{{ fixedDepositProduct.digitsAfterDecimal }}</span>
  </div>

  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Currency in multiples of' | translate }}:</span>
    <span class="flex-60">{{ fixedDepositProduct.inMultiplesOf }}</span>
  </div>

  <h3 class="mat-h3 flex-100">{{ 'labels.heading.Terms' | translate }}</h3>

  <mat-divider class="flex-100"></mat-divider>
  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Deposit Amount' | translate }}:</span>
    <span class="flex-60">{{
      fixedDepositProduct.depositAmount +
        ' (Min: ' +
        (fixedDepositProduct.minDepositAmount
          ? fixedDepositProduct.minDepositAmount
          : fixedDepositProduct.depositAmount) +
        ', Max: ' +
        (fixedDepositProduct.maxDepositAmount
          ? fixedDepositProduct.maxDepositAmount
          : fixedDepositProduct.depositAmount) +
        ')'
    }}</span>
  </div>

  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Interest Compounding Period' | translate }}:</span>
    <span class="flex-60">{{
      fixedDepositProduct.interestCompoundingPeriodType
        | find: fixedDepositProductsTemplate.interestCompoundingPeriodTypeOptions : 'id' : 'value'
    }}</span>
  </div>

  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Interest Posting Period' | translate }}:</span>
    <span class="flex-60">{{
      fixedDepositProduct.interestPostingPeriodType
        | find: fixedDepositProductsTemplate.interestPostingPeriodTypeOptions : 'id' : 'value'
    }}</span>
  </div>

  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Interest Calculated using' | translate }}:</span>
    <span class="flex-60">{{
      fixedDepositProduct.interestCalculationType
        | find: fixedDepositProductsTemplate.interestCalculationTypeOptions : 'id' : 'value'
    }}</span>
  </div>

  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Days in Year' | translate }}:</span>
    <span class="flex-60">{{
      fixedDepositProduct.interestCalculationDaysInYearType
        | find: fixedDepositProductsTemplate.interestCalculationDaysInYearTypeOptions : 'id' : 'value'
    }}</span>
  </div>

  <h3 class="mat-h3 flex-100">{{ 'labels.heading.Settings' | translate }}</h3>

  <mat-divider class="flex-100"></mat-divider>
  @if (fixedDepositProduct.lockinPeriodFrequency) {
    <div class="layout-row flex-100">
      <span class="flex-40">{{ 'labels.inputs.Lock-in Period' | translate }}:</span>
      <span class="flex-60">{{
        fixedDepositProduct.lockinPeriodFrequency +
          ' ' +
          (fixedDepositProduct.lockinPeriodFrequencyType
            | find: fixedDepositProductsTemplate.lockinPeriodFrequencyTypeOptions : 'id' : 'value')
      }}</span>
    </div>
  }

  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Minimum Deposit Term' | translate }}:</span>
    <span class="flex-60">{{
      fixedDepositProduct.minDepositTerm +
        ' ' +
        (fixedDepositProduct.minDepositTermTypeId
          | find: fixedDepositProductsTemplate.periodFrequencyTypeOptions : 'id' : 'value')
    }}</span>
  </div>

  @if (fixedDepositProduct.inMultiplesOfDepositTerm) {
    <div class="layout-row flex-100">
      <span class="flex-40">{{ 'labels.inputs.And thereafter, in Multiples of' | translate }}:</span>
      <span class="flex-60">{{
        fixedDepositProduct.inMultiplesOfDepositTerm +
          ' ' +
          (fixedDepositProduct.inMultiplesOfDepositTermTypeId
            | find: fixedDepositProductsTemplate.periodFrequencyTypeOptions : 'id' : 'value')
      }}</span>
    </div>
  }

  @if (fixedDepositProduct.maxDepositTerm) {
    <div class="layout-row flex-100">
      <span class="flex-40">{{ 'labels.inputs.Maximum Deposit Term' | translate }}:</span>
      <span class="flex-60">{{
        fixedDepositProduct.maxDepositTerm +
          ' ' +
          (fixedDepositProduct.maxDepositTermTypeId
            | find: fixedDepositProductsTemplate.periodFrequencyTypeOptions : 'id' : 'value')
      }}</span>
    </div>
  }
  <!-- For Pre-mature closure -->
  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Apply Penal Interest (less)' | translate }}:</span>
    <span class="flex-60">{{ fixedDepositProduct.preClosurePenalApplicable | yesNo }}</span>
  </div>

  @if (fixedDepositProduct.preClosurePenalApplicable) {
    <div class="layout-row flex-100">
      <span class="flex-40">{{ 'labels.inputs.Penal Interest' | translate }} (%):</span>
      <span class="flex-60">{{
        fixedDepositProduct.preClosurePenalInterest +
          '% (' +
          (fixedDepositProduct.preClosurePenalInterestOnTypeId
            | find: fixedDepositProductsTemplate.preClosurePenalInterestOnTypeOptions : 'id' : 'value') +
          ')'
      }}</span>
    </div>
  }
  <!--  -->
  <div class="layout-row flex-100">
    <span class="flex-40">{{ 'labels.inputs.Withhold Tax is Applicable' | translate }}:</span>
    <span class="flex-60">{{ fixedDepositProduct.withHoldTax | yesNo }}</span>
  </div>

  @if (fixedDepositProduct.withHoldTax) {
    <div class="layout-row flex-100">
      <span class="flex-40">{{ 'labels.inputs.Tax Group' | translate }}:</span>
      <span class="flex-60">{{
        fixedDepositProduct.taxGroupId | find: fixedDepositProductsTemplate.taxGroupOptions : 'id' : 'name'
      }}</span>
    </div>
  }

  @if (fixedDepositProduct.charts.length !== 0) {
    <div class="layout-row-wrap responsive-column flex-100">
      <h3 class="mat-h3 flex-100">{{ 'labels.heading.Interest Rate Charts' | translate }}</h3>
      <mat-divider class="flex-100"></mat-divider>
      @for (chart of fixedDepositProduct.charts; track chart; let chartIndex = $index) {
        <div class="layout-row-wrap responsive-column flex-100">
          @if (chart.name) {
            <div class="layout-row flex-100">
              <span class="flex-40">{{ 'labels.inputs.Name' | translate }}:</span>
              <span class="flex-60">{{ chart.name }}</span>
            </div>
          }
          @if (chart.description) {
            <div class="layout-row flex-100">
              <span class="flex-40">{{ 'labels.inputs.Description' | translate }}:</span>
              <span class="flex-60">{{ chart.description }}</span>
            </div>
          }
          <div class="layout-row flex-100">
            <span class="flex-40">{{ 'labels.inputs.From Date' | translate }}:</span>
            <span class="flex-60">{{ chart.fromDate | dateFormat }}</span>
          </div>
          @if (chart.endDate) {
            <div class="layout-row flex-100">
              <span class="flex-40">{{ 'labels.inputs.End Date' | translate }}:</span>
              <span class="flex-60">{{ chart.endDate | dateFormat }}</span>
            </div>
          }
          <div class="flex-100">
            <span class="flex-40">{{ 'labels.inputs.Primary Grouping by Amount' | translate }}:</span>
            <span class="flex-60">{{ fixedDepositProduct.isPrimaryGroupingByAmount | yesNo }}</span>
          </div>
          @if (chart.chartSlabs.length !== 0) {
            <table class="mat-elevation-z1 flex-100" mat-table [dataSource]="chart.chartSlabs" multiTemplateDataRows>
              <ng-container matColumnDef="period">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Period' | translate }}</th>
                <td mat-cell *matCellDef="let chartSlab">
                  {{
                    chartSlab.fromPeriod +
                      ' - ' +
                      chartSlab.toPeriod +
                      ' ' +
                      (chartSlab.periodType
                        | find: fixedDepositProductsTemplate.chartTemplate.periodTypes : 'id' : 'value')
                  }}
                </td>
              </ng-container>
              <ng-container matColumnDef="amountRange">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Amount Range' | translate }}</th>
                <td mat-cell *matCellDef="let chartSlab">
                  {{ chartSlab.amountRangeFrom + ' - ' + chartSlab.amountRangeTo }}
                </td>
              </ng-container>
              <ng-container matColumnDef="annualInterestRate">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Interest' | translate }}</th>
                <td mat-cell *matCellDef="let chartSlab">
                  {{ chartSlab.annualInterestRate }}
                </td>
              </ng-container>
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Description' | translate }}</th>
                <td mat-cell *matCellDef="let chartSlab">
                  {{ chartSlab.description }}
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Actions' | translate }}</th>
                <td mat-cell *matCellDef="let chartSlab; let chartSlabIndex = dataIndex">
                  <button
                    mat-button
                    color="primary"
                    (click)="
                      expandChartSlabIndex[chartIndex] =
                        expandChartSlabIndex[chartIndex] === chartSlabIndex ? null : chartSlabIndex
                    "
                    [disabled]="chartSlab.incentives.length === 0"
                  >
                    @if (expandChartSlabIndex[chartIndex] !== chartSlabIndex) {
                      <span>
                        <fa-icon icon="eye" class="m-r-10"></fa-icon>
                        {{ 'labels.buttons.View Incentives' | translate }}
                      </span>
                    }
                    @if (expandChartSlabIndex[chartIndex] === chartSlabIndex) {
                      <span>
                        <fa-icon icon="eye-slash" class="m-r-10"></fa-icon>
                        {{ 'labels.buttons.Hide Incentives' | translate }}
                      </span>
                    }
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="incentives">
                <td
                  mat-cell
                  *matCellDef="let chartSlab; let chartSlabIndex = dataIndex"
                  [attr.colspan]="chartSlabsDisplayedColumns[chartIndex].length"
                >
                  <div
                    class="layout-row-wrap flex-100 incentives"
                    [@expandChartSlab]="chartSlabIndex === expandChartSlabIndex[chartIndex] ? 'expanded' : 'collapsed'"
                  >
                    <mat-card class="layout-row-wrap flex-100">
                      <h4 class="mat-h4 flex-23">
                        {{ 'labels.heading.Incentives' | translate }}
                      </h4>
                      <table class="flex-100 mat-elevation-z1" mat-table [dataSource]="chartSlab.incentives">
                        <ng-container matColumnDef="entityType">
                          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Entity Type' | translate }}</th>
                          <td mat-cell *matCellDef="let incentive">
                            {{
                              incentive.entityType
                                | find: fixedDepositProductsTemplate.chartTemplate.entityTypeOptions : 'id' : 'value'
                            }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="attributeName">
                          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Attribute Name' | translate }}</th>
                          <td mat-cell *matCellDef="let incentive">
                            {{
                              incentive.attributeName
                                | find: fixedDepositProductsTemplate.chartTemplate.attributeNameOptions : 'id' : 'value'
                            }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="conditionType">
                          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Condition Type' | translate }}</th>
                          <td mat-cell *matCellDef="let incentive">
                            {{
                              incentive.conditionType
                                | find: fixedDepositProductsTemplate.chartTemplate.conditionTypeOptions : 'id' : 'value'
                            }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="attributeValue">
                          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Attribute Value' | translate }}</th>
                          <td mat-cell *matCellDef="let incentive">
                            @switch (incentive.attributeName) {
                              @case (2) {
                                <span>{{
                                  incentive.attributeValue
                                    | find: fixedDepositProductsTemplate.chartTemplate.genderOptions : 'id' : 'name'
                                }}</span>
                              }
                              @case (3) {
                                <span>{{ incentive.attributeValue }}</span>
                              }
                              @case (4) {
                                <span>{{
                                  incentive.attributeValue
                                    | find: fixedDepositProductsTemplate.chartTemplate.clientTypeOptions : 'id' : 'name'
                                }}</span>
                              }
                              @case (5) {
                                <span>{{
                                  incentive.attributeValue
                                    | find
                                      : fixedDepositProductsTemplate.chartTemplate.clientClassificationOptions
                                      : 'id'
                                      : 'name'
                                }}</span>
                              }
                            }
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="incentiveType">
                          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Incentive Type' | translate }}</th>
                          <td mat-cell *matCellDef="let incentive">
                            {{
                              incentive.incentiveType
                                | find: fixedDepositProductsTemplate.chartTemplate.incentiveTypeOptions : 'id' : 'value'
                            }}
                          </td>
                        </ng-container>
                        <ng-container matColumnDef="amount">
                          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Amount' | translate }}</th>
                          <td mat-cell *matCellDef="let incentive">
                            {{ incentive.amount | formatNumber }}
                          </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="incentivesDisplayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: incentivesDisplayedColumns"></tr>
                      </table>
                    </mat-card>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="chartSlabsDisplayedColumns[chartIndex]"></tr>
              <tr mat-row *matRowDef="let row; columns: chartSlabsDisplayedColumns[chartIndex]"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: chartSlabsIncentivesDisplayedColumns"
                class="incentives-row"
              ></tr>
            </table>
          }
          <mat-divider class="flex-100"></mat-divider>
        </div>
      }
    </div>
  }

  @if (fixedDepositProduct.charges.length) {
    <div class="layout-row-wrap responsive-column flex-100">
      <h3 class="mat-h3 flex-100">{{ 'labels.heading.Charges' | translate }}</h3>
      <mat-divider class="flex-100"></mat-divider>
      <table class="flex-100 mat-elevation-z1" mat-table [dataSource]="fixedDepositProduct.charges">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Name' | translate }}</th>
          <td mat-cell *matCellDef="let charge">
            {{ charge.name + ', ' + charge.currency.displaySymbol }}
          </td>
        </ng-container>
        <ng-container matColumnDef="chargeCalculationType">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Type' | translate }}</th>
          <td mat-cell *matCellDef="let charge">
            {{ charge.chargeCalculationType.value }}
          </td>
        </ng-container>
        <ng-container matColumnDef="amount">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Amount' | translate }}</th>
          <td mat-cell *matCellDef="let charge">
            {{ charge.amount }}
          </td>
        </ng-container>
        <ng-container matColumnDef="chargeTimeType">
          <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Collected On' | translate }}</th>
          <td mat-cell *matCellDef="let charge">
            {{ charge.chargeTimeType.value }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="chargesDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: chargesDisplayedColumns"></tr>
      </table>
    </div>
  }

  <h3 class="mat-h3 flex-100">{{ 'labels.heading.Accounting' | translate }}</h3>

  <mat-divider class="flex-100"></mat-divider>
  @if (!isNoneAccounting()) {
    <LOSx-view-savings-accounting-details [accountingRule]="accountingRule" [accountingMappings]="accountingMappings">
    </LOSx-view-savings-accounting-details>
  }

  @if (
    fixedDepositProduct.advancedAccountingRules &&
    (fixedDepositProduct.paymentChannelToFundSourceMappings?.length ||
      fixedDepositProduct.feeToIncomeAccountMappings?.length ||
      fixedDepositProduct.penaltyToIncomeAccountMappings?.length)
  ) {
    <div class="layout-row-wrap responsive-column flex-100">
      <h3 class="mat-h3 flex-100">{{ 'labels.heading.Advanced Accounting Rules' | translate }}</h3>
      <mat-divider class="flex-100"></mat-divider>
      @if (fixedDepositProduct.paymentChannelToFundSourceMappings?.length) {
        <div class="flex-100 layout-row-wrap responsive-column">
          <h4 class="mat-h4 flex-100">{{ 'labels.heading.Fund Sources for Payment Channels' | translate }}</h4>
          <table
            class="mat-elevation-z1 flex-100"
            mat-table
            [dataSource]="fixedDepositProduct.paymentChannelToFundSourceMappings"
          >
            <ng-container matColumnDef="paymentTypeId">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Payment Type' | translate }}</th>
              <td mat-cell *matCellDef="let paymentFundSource">
                {{
                  paymentFundSource.paymentTypeId
                    | find: fixedDepositProductsTemplate.paymentTypeOptions : 'id' : 'name'
                }}
              </td>
            </ng-container>
            <ng-container matColumnDef="fundSourceAccountId">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fund Source' | translate }}</th>
              <td mat-cell *matCellDef="let paymentFundSource">
                {{
                  paymentFundSource.fundSourceAccountId
                    | find: fixedDepositProductsTemplate.accountingMappingOptions.assetAccountOptions : 'id' : 'name'
                }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="paymentFundSourceDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: paymentFundSourceDisplayedColumns"></tr>
          </table>
        </div>
      }
      @if (fixedDepositProduct.feeToIncomeAccountMappings?.length) {
        <div class="flex-100 layout-row-wrap responsive-column">
          <h4 class="mat-h4 flex-100">{{ 'labels.heading.Fees to Specific Income Accounts' | translate }}</h4>
          <table
            class="mat-elevation-z1 flex-100"
            mat-table
            [dataSource]="fixedDepositProduct.feeToIncomeAccountMappings"
          >
            <ng-container matColumnDef="chargeId">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Fees' | translate }}</th>
              <td mat-cell *matCellDef="let feesIncome">
                {{ feesIncome.chargeId | find: fixedDepositProductsTemplate.chargeOptions : 'id' : 'name' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incomeAccountId">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
              <td mat-cell *matCellDef="let feesIncome">
                {{
                  feesIncome.incomeAccountId
                    | find: fixedDepositProductsTemplate.accountingMappingOptions.incomeAccountOptions : 'id' : 'name'
                }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
          </table>
        </div>
      }
      @if (fixedDepositProduct.penaltyToIncomeAccountMappings?.length) {
        <div class="flex-100 layout-row-wrap responsive-column">
          <h4 class="mat-h4 flex-100">{{ 'labels.heading.Penalties to Specific Income Accounts' | translate }}</h4>
          <table
            class="mat-elevation-z1 flex-100"
            mat-table
            [dataSource]="fixedDepositProduct.penaltyToIncomeAccountMappings"
          >
            <ng-container matColumnDef="chargeId">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Penalty' | translate }}</th>
              <td mat-cell *matCellDef="let penaltyIncome">
                {{ penaltyIncome.chargeId | find: fixedDepositProductsTemplate.penaltyOptions : 'id' : 'name' }}
              </td>
            </ng-container>
            <ng-container matColumnDef="incomeAccountId">
              <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Income Account' | translate }}</th>
              <td mat-cell *matCellDef="let penaltyIncome">
                {{
                  penaltyIncome.incomeAccountId
                    | find: fixedDepositProductsTemplate.accountingMappingOptions.incomeAccountOptions : 'id' : 'name'
                }}
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="feesPenaltyIncomeDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: feesPenaltyIncomeDisplayedColumns"></tr>
          </table>
        </div>
      }
    </div>
  }
</div>

<div class="layout-row responsive-column align-center gap-2px margin-t">
  <button mat-raised-button matStepperPrevious>
    <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Previous' | translate }}
  </button>
  <button mat-raised-button [routerLink]="['../']">
    {{ 'labels.buttons.Cancel' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="submitEvent.emit()">
    {{ 'labels.buttons.Submit' | translate }}
  </button>
</div>
